export default __webpack_public_path__ + "static/service_scanning-d859d9fb9b00ff2a19f895a267cec157.webp";